// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/hazardous-attitudes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/hazardous-attitudes/hazardous-attitudes.js';

mount([g0]);
